export enum LicenseState {
  licensed = 'licensed',
  unlicensed = 'unlicensed'
}